import { withSwiperPage } from '@ad-lucy/components/builderComponents/VastVideo/withSwiperPage';
import { Arrows } from '@ad-lucy/components/nav/NavigationArrow/types';
import {
  CREATIVE_TYPE,
  type CreativesConfig,
  defaultCreativesConfig,
} from '@ad-lucy/config/creatives';
import { GlobalPayout } from '@ad-lucy/utils/types';
import { lazy } from 'react';
import type { componentNames } from './componentNames';

type SaCreativesConfigComponentKeys = (typeof componentNames)[number];

export const saConfig: CreativesConfig<SaCreativesConfigComponentKeys> = {
  ...defaultCreativesConfig,
  id: CREATIVE_TYPE.SA,
  name: 'Story Ad',
  settings: {
    ...defaultCreativesConfig.settings,
    forceAutoplay: true,
    commonMuteState: true,
    playIfNotInActiveTab: true,
    forceGlobalPayout: GlobalPayout.NO_PAYOUT_ON_HOVER,
    headerPadding: {
      sitebar: '44',
      mobile: '0',
    },
    footerPadding: {
      sitebar: '34',
      mobile: '0',
    },
  },
  breakpoints: {
    ...defaultCreativesConfig.breakpoints,
    mobile: '(max-width: 449px)',
    billboard:
      '(max-width: calc(100vh * (16 / 5) + 4px)) and (min-width: calc(100vh * (16 / 5) - 4px)) and (max-height: calc(100vw * (5 / 16) + 4px)) and (min-height: calc(100vw * (5 / 16) - 4px))',
  },
  navigation: {
    ...defaultCreativesConfig.navigation,
    defaults: {
      ...defaultCreativesConfig.navigation.defaults,
      pauseOnMouseEnter: false,
    },
    arrows: Arrows.SIMPLE,
    transition: 'fade',
  },
  layer: {
    defaults: {
      ...defaultCreativesConfig.layer.defaults,
    },
  },
  components: {
    callToAction: {
      ...defaultCreativesConfig.components.callToAction,
    },
    closeAd: {
      ...defaultCreativesConfig.components.closeAd,
    },
    copyright: {
      ...defaultCreativesConfig.components.copyright,
    },
    countdown: {
      ...defaultCreativesConfig.components.countdown,
    },
    custom: {
      ...defaultCreativesConfig.components.custom,
    },
    headerLogo: {
      ...defaultCreativesConfig.components.headerLogo,
    },
    image: {
      ...defaultCreativesConfig.components.image,
    },
    mediaControls: {
      ...defaultCreativesConfig.components.mediaControls,
    },
    modal: {
      ...defaultCreativesConfig.components.modal,
    },
    socialFlyoutBar: {
      ...defaultCreativesConfig.components.socialFlyoutBar,
    },
    socialMediaBar: {
      ...defaultCreativesConfig.components.socialMediaBar,
    },
    socialmedia: {
      ...defaultCreativesConfig.components.socialmedia,
    },
    socialmediaFooter: {
      ...defaultCreativesConfig.components.socialmediaFooter,
    },
    stickyCTA: {
      ...defaultCreativesConfig.components.stickyCTA,
    },
    stickyImage: {
      ...defaultCreativesConfig.components.stickyImage,
    },
    stickyText: {
      ...defaultCreativesConfig.components.stickyText,
    },
    spotlights: {
      ...defaultCreativesConfig.components.spotlights,
    },
    spotlightsArea: {
      ...defaultCreativesConfig.components.spotlightsArea,
    },
    terms: {
      ...defaultCreativesConfig.components.terms,
    },
    text: {
      ...defaultCreativesConfig.components.text,
      defaults: {
        ...defaultCreativesConfig.components.text.defaults,
        headerFooterPadding: true,
      },
    },
    hover: {
      ...defaultCreativesConfig.components.hover,
      defaults: {
        ...defaultCreativesConfig.components.hover.defaults,
        footerPadding: true,
      },
    },
    vastVideoLight: {
      ...defaultCreativesConfig.components.vastVideoLight,
      wrapper: withSwiperPage(
        lazy(() => import('@ad-lucy/components/builderComponents/VastVideo/VastVideoLight')),
      ),
    },
    vastVideoXL: {
      ...defaultCreativesConfig.components.vastVideoXL,
      defaults: {
        ...defaultCreativesConfig.components.vastVideoXL.defaults,
        showPlayButton: false,
      },
    },
    sharingButtonFooter: {
      ...defaultCreativesConfig.components.sharingButtonFooter,
      wrapper: lazy(
        () => import('@ad-lucy/sa/components/styledBuilderComponents/StyledSharingButtonFooter'),
      ),
    },
    enhancedStore: {
      ...defaultCreativesConfig.components.enhancedStore,
      wrapper: lazy(
        () => import('@ad-lucy/sa/components/styledBuilderComponents/StyledEnhancedStore'),
      ),
    },
  },
};
